import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";
import TextInput from "../../inputs/TextInput";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

const RffFileDisplayName = React.memo(function RffFileDisplayName({
  name,
  label,
  required,
  placeholder = "",
  suppressGrid = false,
  size,
  helperText,
  disabled,
  testing,
  sx,
}) {
  // Only recreate validator when "required" changes
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required]
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      required={required}
      testing={testing}
    >
      <Field
        name={name}
        validate={validate}
        // Subscribe to meta.initial for original value
        subscription={{
          value: true,
          touched: true,
          error: true,
          initial: true,
        }}
        render={({ input, meta }) => {
          const handleBlur = (event) => {
            // First update form state
            input.onBlur(event);

            // Determine original extension from initial value
            const originalName = meta.initial || "";
            const originalExtension = originalName
              .split(".")
              .pop()
              .toLowerCase();

            // Strip any extension from current input
            const currentValue = input.value || "";
            const baseName = currentValue.replace(/\.[^/.]+$/, "");

            // Reapply original extension
            const updatedName = `${baseName}.${originalExtension}`;
            if (updatedName !== currentValue) {
              input.onChange(updatedName);
            }
          };

          return (
            <TextInput
              {...input}
              sx={sx}
              onBlur={handleBlur}
              disabled={disabled}
              placeholder={placeholder}
              error={meta.touched && !!meta.error}
              helperText={(meta.touched && meta.error) || helperText}
            />
          );
        }}
      />
    </RffInputWrapper>
  );
});

export default RffFileDisplayName;
